var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.547 7.86581C10.3675 7.69392 10.3675 7.41524 10.547 7.24335L14.6258 3.33751H13.3926C13.144 3.33751 12.9426 3.13604 12.9426 2.88751C12.9426 2.63899 13.144 2.43751 13.3926 2.43751L15.6988 2.43751C15.758 2.42992 15.8184 2.43336 15.8765 2.44785C16.0033 2.47549 16.1101 2.55657 16.1721 2.66629C16.2245 2.75233 16.2438 2.85173 16.2301 2.94764V5.13583C16.2301 5.38436 16.0286 5.58583 15.7801 5.58583H15.7403C15.4917 5.58583 15.2903 5.38436 15.2903 5.13583V3.97407L11.2116 7.87974C11.0321 8.05163 10.7411 8.05163 10.5616 7.87974L10.547 7.86581ZM3.85327 2.81268H9.47829V3.71252H4.0783C4.03687 3.71252 4.0033 3.7461 4.0033 3.78752V14.5875C4.0033 14.6289 4.03687 14.6625 4.0783 14.6625H14.8783C14.9197 14.6625 14.9533 14.6289 14.9533 14.5875V8.72049H15.8533V14.8127C15.8533 15.2269 15.5175 15.5627 15.1033 15.5627H3.85327C3.43906 15.5627 3.10327 15.2269 3.10327 14.8127V3.56268C3.10327 3.14847 3.43906 2.81268 3.85327 2.81268Z",
    fill: "#3D3D3D",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAction);
export default __webpack_public_path__ + "static/media/action.40bc7d62d37486c918efd37d83ce8195.svg";
export { ForwardRef as ReactComponent };